module.exports = __webpack_public_path__ + "static/img/pay-wechat11.8011e0a5.png";